import React from 'react';

// Styles
import { Container } from './styles';

// Interface
interface Props {
  children: React.ReactNode;
}

export function BoxImage({ children }: Props) {
  return <Container>{children}</Container>;
}
